An array of additional free text descriptions of the person's attendance at the institution.

This typically includes activities, honours, awards or specialities achieved during their study.
